module.exports = __webpack_public_path__ + "static/img/type_bg.2c5931c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/type_bg.png
// module id = x/Kl
// module chunks = 1